function addAsyncScript(src: string): void {
  if (document.querySelector(`script[src="${src}"]`)) return

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = src
  const firstScript = document.getElementsByTagName('script')[0]

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
    return
  }

  document.head.appendChild(script)
}

function bootstrapMetaPixel(): void {
  if (window.fbq) return

  const fbq = function (...args: any[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  }

  ;(window as any).fbq = fbq
  ;(window as any)._fbq = fbq
  ;(fbq as any).push = fbq
  ;(fbq as any).loaded = true
  ;(fbq as any).version = '2.0'
  ;(fbq as any).queue = []

  addAsyncScript('https://connect.facebook.net/en_US/fbevents.js')

  const pixelId = import.meta.env.VITE_META_PIXEL_ID
  if (pixelId) {
    window.fbq('init', pixelId)
  }
}

function bootstrapTikTokPixel(): void {
  if (window.ttq) return

  const methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie'
  ]

  const ttq = ((window as any).ttq = (window as any).ttq || [])

  ;(ttq as any).methods = methods
  ;(ttq as any).setAndDefer = function (target: any, key: string) {
    target[key] = function (...args: any[]) {
      target.push([key, ...args])
    }
  }

  for (const method of methods) {
    ;(ttq as any).setAndDefer(ttq, method)
  }

  ;(ttq as any).instance = function (instanceKey: string) {
    const instance = (ttq as any)._i?.[instanceKey] || []
    for (const method of methods) {
      ;(ttq as any).setAndDefer(instance, method)
    }
    return instance
  }
  ;(ttq as any).load = function (sdkId: string, options?: Record<string, unknown>) {
    const src = 'https://analytics.tiktok.com/i18n/pixel/events.js'
    ;(ttq as any)._i = (ttq as any)._i || {}
    ;(ttq as any)._i[sdkId] = []
    ;(ttq as any)._i[sdkId]._u = src
    ;(ttq as any)._t = (ttq as any)._t || {}
    ;(ttq as any)._t[sdkId] = +new Date()
    ;(ttq as any)._o = (ttq as any)._o || {}
    ;(ttq as any)._o[sdkId] = options || {}

    addAsyncScript(`${src}?sdkid=${sdkId}&lib=ttq`)
  }
  ;(window as any).TiktokAnalyticsObject = 'ttq'

  const pixelId = import.meta.env.VITE_TIKTOK_PIXEL_ID
  if (pixelId) {
    ;(ttq as any).load(pixelId)
  }
}

function bootstrapSnapPixel(): void {
  if (window.snaptr) return

  const snaptr = function (...args: any[]) {
    if ((snaptr as any).handleRequest) {
      ;(snaptr as any).handleRequest.apply(snaptr, args)
    } else {
      ;(snaptr as any).queue.push(args)
    }
  }

  ;(window as any).snaptr = snaptr
  ;(snaptr as any).queue = []

  addAsyncScript('https://sc-static.net/scevent.min.js')

  const pixelId = import.meta.env.VITE_SNAPCHAT_PIXEL_ID
  if (pixelId) {
    window.snaptr('init', pixelId)
  }
}

function bootstrapRedditPixel(): void {
  if (window.rdt) return

  const rdt = function (...args: any[]) {
    if ((rdt as any).sendEvent) {
      ;(rdt as any).sendEvent.apply(rdt, args)
    } else {
      ;(rdt as any).callQueue.push(args)
    }
  }

  ;(window as any).rdt = rdt
  ;(rdt as any).callQueue = []

  addAsyncScript('https://www.redditstatic.com/ads/pixel.js')

  const pixelId = import.meta.env.VITE_REDDIT_PIXEL_ID
  if (pixelId) {
    window.rdt('init', pixelId)
  }
}

function loadGooglePayScript(): void {
  addAsyncScript('https://pay.google.com/gp/p/js/pay.js')
}

function safelyBootstrap(name: string, bootstrap: () => void): void {
  try {
    bootstrap()
  } catch (error) {
    console.warn(`Failed to bootstrap ${name}`, error)
  }
}

export function setupCspSafeBootstraps(): void {
  safelyBootstrap('Google Pay', loadGooglePayScript)
  safelyBootstrap('Meta Pixel', bootstrapMetaPixel)
  safelyBootstrap('TikTok Pixel', bootstrapTikTokPixel)
  safelyBootstrap('Snap Pixel', bootstrapSnapPixel)
  safelyBootstrap('Reddit Pixel', bootstrapRedditPixel)
}
